import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ICcyPairLookupService } from "../ICcyPairLookupService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CcyPairLookupService
  extends BaseLookupService<string, CubiqTS.CurrencyPairImpl>
  implements ICcyPairLookupService
{
  constructor() {
    super(CubiqTS.CurrencyPairImpl);
  }

  getCcyPair(base: string, nonbase: string, fetchInvert: boolean = true): CubiqTS.CurrencyPairImpl {
    let ccyPair: CubiqTS.CurrencyPairImpl = this.getItem(base + nonbase);
    if (!ccyPair && fetchInvert) {
      ccyPair = this.getItem(nonbase + base);
    }
    return ccyPair;
  }

  getItemKey(item: CubiqTS.CurrencyPairImpl): string {
    return item.base + item.nonBase;
  }

  public expandWildcardPairs(pairs: Array<string>): Array<string> {
    let resultSet = new Set<string>();

    let currenciesMasked = pairs.filter((p) => p.includes("***")).map((p) => p.replace("***", ""));
    this.getAll()
      .filter(
        (pair) => currenciesMasked.includes(pair.base) || currenciesMasked.includes(pair.nonBase),
      )
      .forEach((p) => resultSet.add(p.base + p.nonBase));

    pairs
      .filter((p) => !p.includes("***"))
      .forEach((pairName) => {
        if (this.getItem(pairName) != null) {
          resultSet.add(pairName);
        }
      });

    return [...resultSet];
  }
}
